import { render, staticRenderFns } from "./ModalChallenge.vue?vue&type=template&id=2f5edf16&scoped=true&"
import script from "./ModalChallenge.vue?vue&type=script&lang=js&"
export * from "./ModalChallenge.vue?vue&type=script&lang=js&"
import style0 from "./ModalChallenge.vue?vue&type=style&index=0&id=2f5edf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5edf16",
  null
  
)

export default component.exports